import Dialog from '@mui/material/Dialog';
import styled from 'styled-components';
import getSubjectsType from '../../utils/get-Subject-Types';

interface DialogProps {
  $subject: string;
  $isterm?: boolean;
}

export const StyledButton = styled.button<DialogProps>`
  border: 1px solid #FF9F9F;
  transition: .3s;

  &:hover {
    background-color: #F6D8D4;
  }

  border-radius: 20px;
  padding: 8px 16px;
  background-color: transparent;

  ${({ theme }) => theme.typography.font}
  font-weight: 600;

  cursor: pointer;
`;

export const DialogContainer = styled.div<DialogProps>`
  display: inline;

  button {
    border-bottom: 3px solid #FF9F9F;
    background: #FFE0DC;
    min-width: unset;
    padding: ${({ $isterm }) => ($isterm ? '0 8px' : '8px')};
    text-transform: none;

    &:hover {
      background-color: #F6D8D4;
    }
  }

  span {
    border-radius: 4px;
    color: ${({ theme }) => theme.colors.grayscale[20]};
    ${({ theme }) => theme.typography.normal};
    font-weight: 600;

    ${({ $isterm }) => {
      if (!$isterm) {
        return `
          line-height: 0;
          height: 10px;
          letter-spacing: 0;
          font-size: 14px;
        `;
      }
    }}

    &:hover {
      text-decoration: none;
    }
  }
`;

export const TitleDialog = styled.h5<DialogProps>`
  color: #FF9F9F;
  ${({ theme }) => theme.typography.h5}
  font-family: "Museo";
`;

export const StyledDialog = styled(Dialog)`
  & .MuiPaper-root {
    border-radius: 8px;
    max-height: 90%;
    height: auto;
    padding: 16px 18px;
    gap: 16px;

    @media (max-width: 900px){
      max-width: 50%;
    }

    @media (max-width: 600px){
      max-width: 90%;
    }
  }

  h5 {
    ${({ theme }) => theme.typography.h5}
    font-weight: 800;
  }

  p {
    color: ${({ theme }) => theme.colors.grayscale[20]};
    line-height: 24px;
    ${({ theme }) => theme.typography.modalBody};
  }

  .listaNumerica, .listaBullets {
    padding-left: 20px;
  }

  .listaNumerica {
    list-style-type: decimal;
  }

  .listaBullets {
    list-style-type: disc;
  }
`;
